import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Whether or not the new Move To Folder menu is enabled, which includes a new design and updated MRU list.
 */
export const moveToFolderNewMenuCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return (
            isGlobalFeatureEnabled('fp-movetofolder-menu-v2') ||
            isGlobalFeatureEnabled('fp-movetofolder-menu-maxitems-5') ||
            isGlobalFeatureEnabled('fp-movetofolder-menu-maxitems-7')
        );
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
};
